import $ from 'jquery';

const activationCardModal = () => {

    const selectors = {
        btn: '.js-activation-card-modal',
        mobileOverlay: '.js-mobile-menu-overlay',
        mobileMenu: '.js-mobile-menu'
    };

    const states = {
        active: 'active'
    };

    $(selectors.btn).on('click', () => {
        $('body').removeClass(states.active);
        $(selectors.mobileOverlay).removeClass(states.active);
        $(selectors.mobileMenu).removeClass(states.active);
    });
};

export default activationCardModal;
